import React from 'react';
import { useNavigate, useRouteError, isRouteErrorResponse } from 'react-router-dom';

export default function ProductLoadError() {
  const err = useRouteError();
  const navigate = useNavigate();
  const is404 = isRouteErrorResponse(err) && err.status === 404;

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center px-6 py-16 text-center">
      <h1 className="text-xl font-semibold text-gray-900 mb-2">
        {is404 ? 'Producto no disponible' : 'No se pudo cargar el producto'}
      </h1>
      <p className="text-gray-600 max-w-md mb-8">
        {is404
          ? 'Este artículo no está a la venta, aún no está publicado o ya no existe.'
          : 'Ocurrió un error al cargar la página. Probá de nuevo más tarde.'}
      </p>
      <button
        type="button"
        className="px-6 py-2 rounded-lg bg-black text-white text-sm font-medium hover:bg-gray-800"
        onClick={() => navigate('/')}
      >
        Volver al inicio
      </button>
    </div>
  );
}
